export const ResultsStates = {
	NO_RESULTS: 'noResults',
	INITIAL: 'initial',
	RESULTS: 'results',
	ERROR: 'error',
	IS_LOADING: 'isLoading',
} as const;
export type ResultsStates = (typeof ResultsStates)[keyof typeof ResultsStates];

export const FetchStatus = {
	INITIAL: 'initial',
	LOADING: 'loading',
	SUCCESS: 'success',
	ERROR: 'error',
};
export type FetchStatus = (typeof FetchStatus)[keyof typeof FetchStatus];
